module.exports = __webpack_public_path__ + "static/media/php.361431b5.svg";